import { ElementRef, Renderer2, EventEmitter } from '@angular/core';
var ComponentQuestionnaireGrade = (function () {
    function ComponentQuestionnaireGrade(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.outPutLevel = new EventEmitter(); //回传打分等级
    }
    ComponentQuestionnaireGrade.prototype.ngOnInit = function () {
        this.afterQuestionnaireScoreArray = this.questionnaireScoreArray.filter(function (d) { return d.level !== 0; });
    };
    ComponentQuestionnaireGrade.prototype.ngAfterViewInit = function () {
    };
    // 打分
    ComponentQuestionnaireGrade.prototype.giveMark = function (index) {
        for (var i = 0, len = this.afterQuestionnaireScoreArray.length; i < len; i += 1) {
            if (i <= index) {
                this.renderer.addClass(this.el.nativeElement.querySelector('.star-' + i), 'active');
            }
            else {
                this.renderer.removeClass(this.el.nativeElement.querySelector('.star-' + i), 'active');
            }
        }
        this.outPutLevel.emit(index);
    };
    return ComponentQuestionnaireGrade;
}());
export { ComponentQuestionnaireGrade };



// WEBPACK FOOTER //
// ./src/component/questionnire/child-grade/component.questionnaire-grade.ts.pre-build-optimizer.js